/* OsLinkEnableComponent.js */

"use strict";

const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl
    .DefaultColumnComponent;
const Renderer = require("./OsLinkEnableRenderer");
const _ = require("lodash");

class IotOsLinkEnableComponent extends DefaultColumnComponent {
    constructor(value, context) {
        super(value);
        this._value = value;
        this._context = context;
        this._planId = context.planId;
        this._planDetails = context.planDetails || {};
        this._planEntityDef = context.planEntityDef;
        this._plan = context.planDetails.plan || {};
        this._onIgnoreLinkIdsChanged = this._onIgnoreLinkIdsChanged.bind(this);
        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {
        if (this._plan) {
            this.unregisterPlanListeners();
        }
    }

    registerPlanListeners() {
        this._plan.on("IgnoreLinkIdsPropertyUpdated", this._onIgnoreLinkIdsChanged);
    }

    unregisterPlanListeners() {
        this._plan.removeListener("IgnoreLinkIdsPropertyUpdated", this._onIgnoreLinkIdsChanged);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._renderer = undefined;
        this._value = undefined;
        this._context = undefined;
        this._planId = undefined;
        this._planDetails = undefined;
        this._planEntityDef = undefined;
        this._plan = undefined;
        this._onIgnoreLinkIdsChanged = undefined;
        return prom;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onIgnoreLinkIdsChanged() {
        this.setOsLinkEnable(this.getEnableValue());
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    setValue(newVal) {
        if (!_.isUndefined(newVal)) {
            this._value = newVal;
            this.setOsLinkEnable(this.getEnableValue());
        }
    }

    getValue() {
        return this.getEnableValue();
    }

    setOsLinkEnable(newVal) {
        this.emit("OsLinkEnable", newVal);
        return this;
    }

    async enableLink(val) {
        try {
            const plan = await this._planEntityDef.loadOdmOsUpgradePlan(
                this._plan.tenantId,
                this._planId
            );
            const ignoreLinkIds = plan.getIgnoreLinkIds() || [];

            if (val) {
                _.pull(ignoreLinkIds, this._value.id);
            } else {
                ignoreLinkIds.push(this._value.id);
            }

            plan.setIgnoreLinkIds(ignoreLinkIds);

            if (plan.linkStatus !== "DRAFT") {
                plan.setStatus("DRAFT");
            }

            await plan.update();
        } catch (error) {
            console.error("Failed to update link enable status:", error);
            throw error;
        }
    }

    getEnableValue() {
        if (!this._value) {
            return false;
        }
        const linkId = this._value.id;
        const ignoreLinkIds = this._plan.getIgnoreLinkIds() || [];
        return !_.includes(ignoreLinkIds, linkId);
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = IotOsLinkEnableComponent;
